<app-user-header class="d-lg-none"></app-user-header> 


<div class="wrapperi">
  <div class="p-4">
    <div class="col-12">

      <div class="pointer" (click)="goBack()">
          <p class="semiboldtextblue16 mb-0"><i class="fal normaltextblue16 fa-chevron-left icon-blue me-2"></i>Takaisin</p>
      </div>
  </div>
  </div>


  <div class="ps-4 pe-4 pt-2">
    <div class="bg-w p-4 formed-shadow">
  <div class="col-12 p-0 m-0">
    <div class="col-12 p-0 input-cover ">
          <p class="semiboldtextblue24">{{title}}</p>
      </div>

      <div id="loader" class="loader-container mt-4" *ngIf="isLoading">
        <div class="loader mx-auto"></div>
        <p class="text-center pt-3">Tietoja lisätään...</p>
      </div>

      <div style="display: block;" id="form-container p-0" class="">
        <form class="flex-row " [formGroup]="form"
        (ngSubmit)="onSubmit()">

          <!-- Yrityksen nimi ja sukunimi -->
          <div class="col-12 m-0 pt-2">
            <p class="semiboldgraytext16 mb-2">Toimipisteen nimi</p>
            <div class="form-floating mb-2 col-12 col-md-4 ps-0">
                <input type="text" placeholder="Yrityksen nimi" formControlName="businessName" id="businessName" class="form-control" [class.invalid-input]="businessName.errors && businessName.touched" required>
                <label for="businessName">Toimipisteen nimi</label>
                <div class="my-alerts" *ngIf="businessName.invalid && businessName.touched">
                <p class="mt-2" *ngIf="businessName.errors.required">Nimi on pakollinen</p>
                <p *ngIf="businessName.errors.businessName"> Vaaditaan kunnollinen Nimi</p>
                </div>
            </div>

        </div>

        <p class="semiboldgraytext16 mb-2 mt-4">Valitse alue</p>
        <div class="col-4 m-0 pt-2">
            <div class="form-floating mb-2 col-12  p-0">
                <select type="text" placeholder="Alue"  id="wellfareArea" class="form-control form-select" required>
                    <option value=""></option>
                    <option *ngFor="let data of wellfareAreas" [value]="data.id">{{data.name_fi}}</option>
                </select>
                <label for="wellfareArea">Alue</label>

            </div>

        </div>

            <!-- Puhelin -->
            <p class="semiboldgraytext16 mb-2 mt-4">Osoite</p>
            <div class="col-12 row p-0 m-0 pt-2">
              <div class="form-floating mb-2 col-12 col-md-4 ps-0">
                <input type="text" placeholder="Osoite" formControlName="address" id="address" class="form-control">
                <label for="address">Osoite</label>
            </div>

                <div class="form-floating mb-2 col-12 col-md-4 p-0">
                    <input type="text" placeholder="Postinumero" formControlName="zip" id="zip" class="form-control">
                    <label for="zip">Postinumero</label>
                </div>
                <div class="col-2">
                  <div class="form-floating mb-2 ps-0">
                    <input type="text" placeholder="Postitoimipaikka" formControlName="city" id="city" class="form-control" [class.invalid-input]="city.errors && city.touched" required>
                    <label for="city">Postitoimipaikka</label>
                    <div class="my-alerts" *ngIf="city.invalid && city.touched">
                    <p class="mt-2" *ngIf="city.errors.required">Postitoimipaikka on pakollinen</p>
                    <p *ngIf="city.errors.city"> Vaaditaan kunnollinen Postitoimipaikka</p>
                    </div>
                </div>
                </div>
            </div>


            <!-- Puhelin -->
            <p class="semiboldgraytext16 mb-2 mt-4">Kuvaus</p>
          <div class="col-12 row m-0 pt-2">
            <div class="form-floating mb-2  col-12 col-md-8 p-0">
                <textarea style="height: 250px;" placeholder="Kuvaus" formControlName="description" id="description" class="form-control"></textarea>
                <label for="description">Kuvaus</label>

            </div>
          </div>


            <div class="form-inline mt-2">
              <div class="form-group mb-2 flex-row">
                <button [disabled]="form.invalid" class="btn btn-formed-main-blue "><span *ngIf="routeID">Tallenna</span><span *ngIf="!routeID">Tallenna</span></button>
              </div>
            </div>
          </form>

        </div>
      </div>

</div>
</div>
  </div>
